module.exports = __webpack_public_path__ + "img/not-authorized-dark.4ca4c88d.svg";